import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../basic-features/multi-select-v2/multi-select-v2.component";
import * as i4 from "@ngx-translate/core";
/**
 * @deprecated use v3 version of this component instead
 */
function SearchSelectFilterComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function SearchSelectFilterComponent_div_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementStart(1, "geaui-multi-select-v2", 2);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("panelHide", function SearchSelectFilterComponent_div_0_Template_geaui_multi_select_v2_panelHide_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeFilter());
    })("clearButtonClick", function SearchSelectFilterComponent_div_0_Template_geaui_multi_select_v2_clearButtonClick_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearSelection());
    })("selectChanged", function SearchSelectFilterComponent_div_0_Template_geaui_multi_select_v2_selectChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectionChanged($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 7, (tmp_1_0 = ctx_r1.config == null ? null : ctx_r1.config.label) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "UI-LIB.MULTI-SELECT.SELECT"))("options", ctx_r1.config.options)("floatLabelType", "never")("selected", ctx_r1.initialSelected)("virtualScroll", true)("defaultOpen", true)("virtualScrollItemSize", 44);
  }
}
export class SearchSelectFilterComponent {
  tableService;
  config;
  columnKey = '';
  columnName = '';
  tableId = '';
  open = false;
  openChange = new EventEmitter();
  initialSelected = [];
  subscription;
  constructor(tableService) {
    this.tableService = tableService;
  }
  handleKeyboardEvent(event) {
    if (event.key === 'Escape') {
      this.closeFilter();
    }
  }
  ngOnInit() {
    this.subscription = this.tableService.getFilterTableSettings(this.tableId).subscribe(settings => {
      this.config?.options.forEach(option => {
        if (settings.columns[this.columnKey]?.filter?.find(filterOption => filterOption === option.value)) {
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
      this.initialSelected = this.config?.options.filter(option => option.selected).map(option => option.value) ?? [];
    });
  }
  closeFilter() {
    this.openChange.emit(false);
  }
  selectionChanged(options) {
    this.config?.options.forEach(option => {
      option.selected = options.some(selectedOption => selectedOption.value === option.value);
    });
    this.confirmSelection();
  }
  clearSelection() {
    this.tableService.updateFilterTableSettings(this.tableId, {
      columns: {
        [this.columnKey]: {
          filter: []
        }
      },
      page: 0
    });
    this.closeFilter();
  }
  confirmSelection() {
    this.tableService.updateFilterTableSettings(this.tableId, {
      columns: {
        [this.columnKey]: {
          filter: this.config?.options.filter(option => option.selected).map(option => option.value)
        }
      },
      page: 0
    });
    this.closeFilter();
  }
  initialSelection() {
    return this.config?.options.filter(x => x.selected);
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static ɵfac = function SearchSelectFilterComponent_Factory(t) {
    return new (t || SearchSelectFilterComponent)(i0.ɵɵdirectiveInject(i1.TableServiceV2));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SearchSelectFilterComponent,
    selectors: [["geaui-search-select-filter"]],
    hostBindings: function SearchSelectFilterComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function SearchSelectFilterComponent_keydown_HostBindingHandler($event) {
          return ctx.handleKeyboardEvent($event);
        }, false, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      config: "config",
      columnKey: "columnKey",
      columnName: "columnName",
      tableId: "tableId",
      open: "open"
    },
    outputs: {
      openChange: "openChange"
    },
    decls: 1,
    vars: 1,
    consts: [["class", "filter-container", 3, "click", 4, "ngIf"], [1, "filter-container", 3, "click"], [3, "panelHide", "clearButtonClick", "selectChanged", "label", "options", "floatLabelType", "selected", "virtualScroll", "defaultOpen", "virtualScrollItemSize"]],
    template: function SearchSelectFilterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, SearchSelectFilterComponent_div_0_Template, 3, 9, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.open);
      }
    },
    dependencies: [i2.NgIf, i3.MultiSelectV2Component, i4.TranslatePipe],
    styles: [".filter-container[_ngcontent-%COMP%]{position:absolute;background-color:var(--geaui-pure-white);top:-16px;width:350px;right:-16px;z-index:3}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchSelectFilterComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-search-select-filter',
      template: "<div class=\"filter-container\" *ngIf=\"open\" (click)=\"$event.stopPropagation()\">\n  <geaui-multi-select-v2\n    [label]=\"config?.label ?? 'UI-LIB.MULTI-SELECT.SELECT' | translate\"\n    [options]=\"config.options\"\n    [floatLabelType]=\"'never'\"\n    [selected]=\"initialSelected\"\n    [virtualScroll]=\"true\"\n    [defaultOpen]=\"true\"\n    [virtualScrollItemSize]=\"44\"\n    (panelHide)=\"closeFilter()\"\n    (clearButtonClick)=\"clearSelection()\"\n    (selectChanged)=\"selectionChanged($event)\"></geaui-multi-select-v2>\n</div>\n",
      styles: [".filter-container{position:absolute;background-color:var(--geaui-pure-white);top:-16px;width:350px;right:-16px;z-index:3}\n"]
    }]
  }], () => [{
    type: i1.TableServiceV2
  }], {
    config: [{
      type: Input
    }],
    columnKey: [{
      type: Input
    }],
    columnName: [{
      type: Input
    }],
    tableId: [{
      type: Input
    }],
    open: [{
      type: Input
    }],
    openChange: [{
      type: Output
    }],
    handleKeyboardEvent: [{
      type: HostListener,
      args: ['document:keydown', ['$event']]
    }]
  });
})();
